import { EmojiPicker as Frimousse } from 'frimousse'
import { SearchIcon } from 'lucide-react'

import { cn } from '@/lib/ui/style-helpers'

const emojiButtonClass = 'flex size-7 items-center justify-center rounded-md text-xl leading-6'

type EmojiPickerProps = {
  onEmojiSelect: (emoji: string) => void
  frequentEmojis?: string[]
}

export const EmojiPicker = ({ onEmojiSelect, frequentEmojis }: EmojiPickerProps) => (
  <Frimousse.Root
    onEmojiSelect={({ emoji }) => onEmojiSelect(emoji)}
    className='flex h-96 w-80 flex-col overflow-hidden rounded-xl border border-main-border-default bg-main-background-card shadow-lg'
  >
    <div className='px-3 pb-2 pt-3'>
      <div className='flex h-8 items-center gap-1.5 rounded border border-main-border-default px-2'>
        <SearchIcon className='size-4 shrink-0 text-main-foreground-tertiary' />
        <Frimousse.Search
          placeholder='Search'
          className='min-w-0 flex-1 bg-transparent text-main-foreground-primary outline-none text-body-default placeholder:text-main-foreground-placeholder'
        />
      </div>
    </div>
    {!!frequentEmojis?.length && (
      <div className='flex flex-col gap-1.5 px-3 pb-1 pt-2'>
        <span className='text-main-foreground-primary text-label-default'>Frequently used</span>
        <div className='flex flex-wrap gap-1'>
          {frequentEmojis.map((emoji) => (
            <button
              key={emoji}
              type='button'
              onClick={() => onEmojiSelect(emoji)}
              className={cn(emojiButtonClass, 'hover:bg-main-background-interactive-list-hover')}
            >
              {emoji}
            </button>
          ))}
        </div>
      </div>
    )}
    <Frimousse.Viewport className='relative flex-1 outline-none'>
      <Frimousse.Loading className='flex h-full items-center justify-center text-main-foreground-tertiary text-body-default'>
        Loading…
      </Frimousse.Loading>
      <Frimousse.Empty className='flex h-full items-center justify-center text-main-foreground-tertiary text-body-default'>
        No emoji found
      </Frimousse.Empty>
      <Frimousse.List
        className='select-none pb-1'
        components={{
          CategoryHeader: ({ category, ...props }) => (
            <div
              {...props}
              className='bg-main-background-card px-3 pb-1.5 pt-2 text-main-foreground-primary text-label-default'
            >
              {category.label}
            </div>
          ),
          Row: ({ children, ...props }) => (
            <div {...props} className='flex gap-1 px-3'>
              {children}
            </div>
          ),
          Emoji: ({ emoji, ...props }) => (
            <button
              {...props}
              className={cn(
                emojiButtonClass,
                emoji.isActive && 'bg-main-background-interactive-list-hover',
              )}
            >
              {emoji.emoji}
            </button>
          ),
        }}
      />
    </Frimousse.Viewport>
  </Frimousse.Root>
)
